import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';

export const slideAnimation = trigger('slideAnimation', [
  transition(':increment', group([
    query(':enter', [
      style({
        transform: 'translateX(100%)'
      }),
      animate('0.7s ease-out', style('*'))
    ]),
    query(':leave', [
      animate('0.7s ease-out', style({
        transform: 'translateX(-100%)'
      }))
    ])
  ])),
  transition(':decrement', group([
    query(':enter', [
      style({
        transform: 'translateX(100%)'
      }),
      animate('0.7s ease-out', style('*'))
    ]),
    query(':leave', [
      animate('0.7s ease-out', style({
        transform: 'translateX(-100%)'
      }))
    ])
  ])
  )
 
]);
export const blinkAnimation = trigger('blinkAnimation', [
  transition('* => *', [
    query('img',style({ transform: 'scale(1)', opacity: 0.5})),
    query('img',
      stagger('600ms', [
        animate('900ms', style({ transform: 'scale(1)', opacity: 1}))
    ])),
  ])
])
export const biDirectSlideAnimation = trigger('biDirectSlideAnimation', [
  transition(':increment', group([
    query(':enter', [
      style({
        transform: 'translateX(100%)'
      }),
      animate('0.7s ease-out', style('*'))
    ]),
    query(':leave', [
      animate('0.7s ease-out', style({
        transform: 'translateX(-100%)'
      }))
    ])
  ])),
  transition(':decrement', group([
    query(':enter', [
      style({
        transform: 'translateX(-100%)'
      }),
      animate('0.7s ease-out', style('*'))
    ]),
    query(':leave', [
      animate('0.7s ease-out', style({
        transform: 'translateX(100%)'
      }))
    ])
  ])
  )
])